import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, ProtectedRoute } from '@zaogig/auth';
import { Toaster } from 'sonner';
import { RoleGuard } from '../components/RoleGuard';
import { useAuthListener } from '../components/useAuthListener';
import EnterpriseConsole from '../pages/EnterpriseConsole';
import EnterpriseProfileCenter from '../pages/EnterpriseProfileCenter';
import JobManagement from '../pages/JobManagement';
import Dashboard from '../pages/Dashboard';

function EnterpriseLoginPlaceholder() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50/50 via-white to-sky-50/50">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-slate-900">企业端登录</h1>
        <p className="text-slate-500 mt-2">请使用企业微信扫码登录</p>
      </div>
    </div>
  );
}

function AppRoutes() {
  useAuthListener();

  return (
    <Routes>
      <Route path="/login" element={<EnterpriseLoginPlaceholder />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <RoleGuard>
              <EnterpriseConsole />
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <RoleGuard>
              <EnterpriseProfileCenter />
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/jobs"
        element={
          <ProtectedRoute>
            <RoleGuard>
              <JobManagement />
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <RoleGuard>
              <Dashboard />
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export function App() {
  const baseUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';
  return (
    <AuthProvider baseUrl={baseUrl}>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}
